(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8665],{

/***/ 66229:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servers/virtual-servers",
      function () {
        return __webpack_require__(99011);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ virtual_servers; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59072);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/head.js
var head = __webpack_require__(93834);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./layout/Layout/index.js + 9 modules
var Layout = __webpack_require__(4967);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/image.js
var next_image = __webpack_require__(70649);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/SSS/SSS.js + 1 modules
var SSS = __webpack_require__(29751);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-loader-spinner@4.0.0_react-dom@18.2.0_react@18.2.0/node_modules/react-loader-spinner/dist/index.js
var dist = __webpack_require__(56538);
// EXTERNAL MODULE: ./store/GlobalStore.js
var GlobalStore = __webpack_require__(36345);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-i18next@13.0.2_i18next@22.4.6_next@12.3.4_react-i18next@12.1.1_react@18.2.0/node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(66264);
;// CONCATENATED MODULE: ./public/SSS/sss-tr-windows-sanal-sunucu.json
var sss_tr_windows_sanal_sunucu_namespaceObject = JSON.parse('{"Sanal sunucu nasıl kiralanır?":"Makdos üzerinden, ihtiyacınıza uygun bir paket seçerek hızlı ve kolay bir şekilde sanal sunucu kiralayabilirsiniz.","Sanal sunucu nasıl yönetilir?":"Makdos’un kullanıcı dostu yönetim paneli ile sanal sunucunuzu kolayca kontrol edebilir, kaynakları yönetebilir ve yedekleme yapabilirsiniz.","Sanal sunucu kaynakları artırılabilir mi?":"Evet, ihtiyaç duyduğunuzda CPU, RAM ve depolama gibi kaynaklarınızı kolayca artırabilirsiniz.","Sanal sunucuların güvenliği nasıl sağlanır?":"Makdos, tüm sanal sunucular için güncel güvenlik önlemleri ve yedekleme sistemleri sunar. Ayrıca, DDoS koruma hizmetimizle sunucularınızı dış tehditlerden korur.","Uptime garantisi nedir?":"Uptime garantisi, sunucunun çalışır durumda olduğu sürenin oranını ifade eder. Makdos, %99,8 uptime garantisi sunar.","Sanal sunucum ne kadar sürede aktif olur?":"Sanal sunucularınız, ödeme işlemi tamamlandıktan sonra genellikle birkaç dakika içinde aktif hale gelir.","Hangi işletim sistemlerini destekliyorsunuz?":"Makdos, Windows ve Linux tabanlı işletim sistemlerini destekler. İhtiyacınıza göre seçim yapabilirsiniz.","Sanal sunucumda istediğim yazılımları çalıştırabilir miyim?":"Evet, sanal sunucularınız üzerinde tam kontrol sahibi olursunuz ve istediğiniz yazılımları kurabilirsiniz.","Sanal sunucu hizmetinizde destek sunuyor musunuz?":"Evet, Makdos olarak 7/24 teknik destek hizmeti sunuyoruz. Herhangi bir sorunda bize ulaşabilirsiniz.","Ödemeyi hangi yöntemlerle yapabilirim?":"Makdos, kredi kartı, banka havalesi ve Paypal ödeme yöntemlerini destekler.","Sanal sunucu hizmetini iptal edebilir miyim?":"Evet, istediğiniz zaman sanal sunucu hizmetinizi iptal edebilirsiniz. Detaylı bilgi için müşteri hizmetlerimizle iletişime geçebilirsiniz.","Yedekleme hizmeti sunuyor musunuz?":"Evet, tüm sanal sunucular için düzenli yedekleme hizmeti sunuyoruz. Yedekleme planlarınızı panelden kolayca ayarlayabilirsiniz.","Birden fazla sanal sunucu kiralayabilir miyim?":"Evet, ihtiyacınıza göre birden fazla sanal sunucu kiralayabilir ve bunları kolayca yönetebilirsiniz.","Sanal sunucumda trafik limiti var mı?":"Makdos’un sanal sunucu hizmetleri genellikle belirli bir trafik limiti ile gelir. Paket detaylarınızı kontrol ederek ihtiyaçlarınıza uygun bir plan seçebilirsiniz.","Sanal sunucumda performans sorunu yaşarsam ne yapabilirim?":"Herhangi bir performans sorunu yaşarsanız, teknik destek ekibimize ulaşabilirsiniz. Ekibimiz sorunu en kısa sürede çözmek için hazırdır."}');
;// CONCATENATED MODULE: ./public/SSS/sss-en-windows-sanal-sunucu.json
var sss_en_windows_sanal_sunucu_namespaceObject = JSON.parse('{"How to rent a virtual server?":"You can rent a virtual server quickly and easily through Makdos by choosing a package suitable for your needs.","How to manage a virtual server?":"With Makdos\' user-friendly management panel, you can easily control your virtual server, manage resources and make backups.","Can virtual server resources be increased?":"Yes, you can easily increase your resources such as CPU, RAM and storage whenever you need.","How are virtual servers secured?":"Makdos offers up-to-date security measures and backup systems for all virtual servers. It also protects your servers from external threats with our DDoS protection service.","What is uptime guarantee?":"Uptime guarantee refers to the percentage of time the server is up and running. Makdos offers 99.8% uptime guarantee.","How long does it take to activate my virtual server?":"Your virtual servers are usually activated within a few minutes after the payment process is completed.","Which operating systems do you support?":"Makdos supports Windows and Linux based operating systems. You can choose according to your needs.","Can I run the software I want on my virtual server?":"Yes, you have full control over your virtual servers and can install the software you want.","Do you offer support for your virtual server service?":"Yes, as Makdos, we offer 24/7 technical support service. You can contact us in case of any problem.","Which payment methods can I use?":"Makdos supports credit card, bank transfer and Paypal payment methods.","Can I cancel my virtual server service?":"Yes, you can cancel your virtual server service at any time. You can contact our customer service for detailed information.","Do you offer backup service?":"Yes, we offer regular backup service for all virtual servers. You can easily set your backup plans from the panel.","Can I rent more than one virtual server?":"Yes, you can rent more than one virtual server according to your needs and manage them easily.","Is there a traffic limit on my virtual server?":"Makdos\' virtual server services usually come with a certain traffic limit. You can choose a plan that suits your needs by checking your package details.","What can I do if I have performance issues with my virtual server?":"If you experience any performance issues, you can contact our technical support team. Our team is ready to solve the problem as soon as possible."}');
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/router.js
var next_router = __webpack_require__(63498);
// EXTERNAL MODULE: ./components/WindowsVirtualServers/VirtualServersTable.js + 2 modules
var VirtualServersTable = __webpack_require__(556);
;// CONCATENATED MODULE: ./components/WindowsVirtualServers/WindowsVirtualServerServices.js



function WindowsVirtualServersServices() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "windowsCloudServer",
        "windowsLang"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative p-5 lg:p-12 services bg-makdosSecondaryGray",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "pb-12 text-5xl font-semibold text-center",
                children: t("windowsCloudServer:whyMakdos")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container grid grid-cols-4 gap-10 mx-auto mb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "z-10 col-span-4 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-5 mb-4 text-lg font-semibold",
                                children: t("windowsCloudServer:boxTitle1")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-cardText",
                                children: t("windowsCloudServer:boxDescription1")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-4 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-5 mb-4 text-lg font-semibold",
                                children: t("windowsCloudServer:boxTitle2")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-cardText",
                                children: t("windowsCloudServer:boxDescription2")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-4 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-5 mb-4 text-lg font-semibold",
                                children: t("windowsCloudServer:boxTitle6")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-cardText",
                                children: t("windowsCloudServer:boxDescription6")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-4 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-5 mb-4 text-lg font-semibold",
                                children: t("windowsCloudServer:boxTitle7")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-cardText",
                                children: t("windowsCloudServer:boxDescription7")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container grid grid-cols-4 gap-10 mx-auto mb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-10 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-5 mb-4 text-lg font-semibold",
                                children: t("windowsCloudServer:boxTitle5")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-cardText",
                                children: t("windowsCloudServer:boxDescription5")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-10 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-5 mb-4 text-lg font-semibold",
                                children: t("windowsCloudServer:boxTitle3")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-cardText",
                                children: t("windowsCloudServer:boxDescription3")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-10 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-5 mb-4 text-lg font-semibold",
                                children: t("windowsCloudServer:boxTitle4")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-cardText",
                                children: t("windowsCloudServer:boxDescription4")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "z-10 col-span-4 col-span-10 p-10 pb-10 bg-white rounded-md border-b-4 border-transparent shadow-lg transition-all duration-500 cursor-pointer servicesCard group lg:col-span-1 hover:border-makdosYellow hover:border-b-4 hover:shadow-2xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-5 mb-4 text-lg font-semibold",
                                children: t("windowsCloudServer:boxTitle8")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-cardText",
                                children: t("windowsCloudServer:boxDescription8")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var WindowsVirtualServerServices = (WindowsVirtualServersServices);

// EXTERNAL MODULE: ./components/PhysicalServers/DidntFindForm.js
var DidntFindForm = __webpack_require__(11883);
;// CONCATENATED MODULE: ./components/WindowsVirtualServers/WhatIsVirtualServer.js




var WhatIsVirtualServer = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "windowsCloudServer"
    ]).t;
    var ref = (0,react.useState)("virtual-server"), activeSection = ref[0], setActiveSection = ref[1];
    var contentRef = (0,react.useRef)(null);
    var itemRefs = (0,react.useRef)([]);
    var sections = [
        {
            id: "virtual-server",
            title: t("common:whatIsAVirtualServer"),
            desc: t("common:whatIsAVirtualServerDesc")
        },
        {
            id: "used-for",
            title: t("common:whatIsAVirtualServerUsedFor"),
            desc: t("common:whatIsAVirtualServerUsedForDesc")
        },
        {
            id: "advantages",
            title: t("common:advantagesOverPhysicalServers"),
            desc: t("common:advantagesOverPhysicalServersDesc")
        },
        {
            id: "security",
            title: t("common:highlightsOfWindowsVirtualServers"),
            desc: t("common:highlightsOfWindowsVirtualServersDesc")
        },
        {
            id: "performance",
            title: t("common:virtualServerUsageAreas"),
            desc: t("common:virtualServerUsageAreasDesc")
        },
        {
            id: "cost-effectiveness",
            title: t("common:securityOfVirtualServers"),
            desc: t("common:securityOfVirtualServersDesc")
        },
        {
            id: "scalability",
            title: t("common:keyFeaturesOfVirtualServerSecurity"),
            desc: t("common:keyFeaturesOfVirtualServerSecurityDesc")
        },
        {
            id: "usability",
            title: t("common:securityAdvantagesOfVirtualServers"),
            desc: t("common:securityAdvantagesOfVirtualServersDesc")
        }, 
    ];
    var handleClick = function(id) {
        var contentBox = contentRef.current; // Container referansı
        var element = document.getElementById(id); // Hedef eleman
        if (element && contentBox) {
            // Elemanın container'a göre top pozisyonunu hesapla
            var elementTop = element.getBoundingClientRect().top - contentBox.getBoundingClientRect().top;
            // Container'ın mevcut scrollTop değerine elemanın pozisyonunu ekle
            var scrollTopValue = contentBox.scrollTop + elementTop - 7;
            // Container içinde scroll yap
            contentBox.scrollTo({
                top: scrollTopValue,
                behavior: "smooth"
            });
        }
    };
    var handleScroll = function() {
        if (!contentRef.current) return;
        var _current = contentRef.current, scrollTop = _current.scrollTop, scrollHeight = _current.scrollHeight, clientHeight = _current.clientHeight;
        // Scroll pozisyonunu kontrol et
        var contentTop = contentRef.current.getBoundingClientRect().top;
        // Her bir öğenin pozisyonunu kontrol et
        if (scrollTop + clientHeight >= scrollHeight - 1) {
            setActiveSection(sections[sections.length - 1].id);
            return;
        } else {
            for(var i = itemRefs.current.length - 1; i >= 0; i--){
                var ref = itemRefs.current[i];
                if (ref) {
                    var rect = ref.getBoundingClientRect();
                    // Eğer öğenin üst kısmı container'ın üst kısmından daha yukarıdaysa, o öğeyi aktif yap
                    if (rect.top < contentTop + 200) {
                        setActiveSection(sections[i].id);
                        return;
                    }
                }
            }
        }
        // Eğer hiçbir şey eşleşmezse, ilk öğeyi aktif yap
        setActiveSection(sections[0].id);
    };
    (0,react.useEffect)(function() {
        var container = contentRef.current;
        if (container) {
            container.addEventListener("scroll", handleScroll);
            handleScroll(); // İlk yüklemede çalıştır
            return function() {
                return container.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        sections
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container px-4 py-10 mx-auto lg:py-20 lg:px-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-2 gap-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hidden col-span-2 lg:col-span-1 lg:block",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col items-center justify-center mb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/whatIsVirtualServer.svg",
                                width: 557,
                                height: 216,
                                alt: t("windowsCloudServer:whatIsAVirtualServer"),
                                title: t("windowsCloudServer:whatIsAVirtualServer")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "space-y-5",
                            children: sections.map(function(section, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    onClick: function() {
                                        return section.id != activeSection && handleClick(section.id);
                                    },
                                    className: "cursor-pointer text-lg font-semibold ".concat(activeSection === section.id ? "text-black " : "text-textGray"),
                                    children: [
                                        "• ",
                                        section.title
                                    ]
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:mt-24 h-[488px] overflow-y-auto customScroll space-y-16 col-span-2 lg:col-span-1",
                    ref: contentRef,
                    children: sections.map(function(section, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: section.id,
                            ref: function(el) {
                                return itemRefs.current[index] = el;
                            },
                            className: "".concat(activeSection == section.id ? "" : "opacity-25", "  ").concat(sections.length == index + 1 ? "pb-32" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-textGray text-3xl px-1 font-semibold  ".concat(activeSection === section.id ? "w-fit bg-gradient-to-b  from-white  via-white  to-[#ffee80]  !leading-[40px]" : ""),
                                    children: section.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-4 text-textGray",
                                    dangerouslySetInnerHTML: {
                                        __html: section.desc
                                    }
                                })
                            ]
                        }, section.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var WindowsVirtualServers_WhatIsVirtualServer = (WhatIsVirtualServer);

;// CONCATENATED MODULE: ./components/WindowsVirtualServers/TechnicalSpecificationsWindowsServers.js



var TechnicalSpecificationsWindowsServers = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "windowsCloudServer"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative p-5 services bg-makdosSecondaryGray",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container px-2 py-10 mx-auto lg:space-x-4 lg:py-20 lg:px-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "font-semibold text-3xl mb-3 lg:text-[40px] lg:text-center text-textGray",
                    children: t("common:technicalSpecificationsWindowsServers")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-sm lg:text-base lg:text-center lg:!mx-[150px] text-textGray",
                    dangerouslySetInnerHTML: {
                        __html: t("common:technicalSpecificationsWindowsServersDesc")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-12 gap-8 mx-auto mt-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center justify-center col-span-12 my-10 lg:col-span-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/windowVirtualServerTechnicalProperty.svg",
                                width: 520,
                                height: 494,
                                alt: t("windowsCloudServer:technicalSpecificationsOfWindowsVirtualServers"),
                                title: t("windowsCloudServer:technicalSpecificationsOfWindowsVirtualServers")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:h-[584px] overflow-y-auto scrollbar-custom lg:pr-10 space-y-8 col-span-12 lg:col-span-7",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm font-semibold lg:text-base text-textGray",
                                            children: [
                                                "• ",
                                                t("common:uninterruptedServiceWithClusterInfrastructure")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm lg:text-base text-textGray",
                                            dangerouslySetInnerHTML: {
                                                __html: t("common:uninterruptedServiceWithClusterInfrastructureDesc")
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm font-semibold lg:text-base text-textGray",
                                            children: [
                                                "• ",
                                                t("common:storageBasedDiskStructure")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm lg:text-base text-textGray",
                                            children: t("common:storageBasedDiskStructureDesc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm font-semibold lg:text-base text-textGray",
                                            children: [
                                                "• ",
                                                t("common:highAvailabilityDynamicResourceManagement")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm lg:text-base text-textGray",
                                            children: t("common:highAvailabilityDynamicResourceManagementDesc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm font-semibold lg:text-base text-textGray",
                                            children: [
                                                "• ",
                                                t("common:highInternetSpeed")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm lg:text-base text-textGray",
                                            children: t("common:highInternetSpeedDesc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm font-semibold lg:text-base text-textGray",
                                            children: [
                                                "• ",
                                                t("common:advancedBackupAndDataManagement")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm lg:text-base text-textGray",
                                            children: t("common:advancedBackupAndDataManagementDesc")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm font-semibold lg:text-base text-textGray",
                                            children: [
                                                "• ",
                                                t("common:flexibleResourceManagement")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm lg:text-base text-textGray",
                                            dangerouslySetInnerHTML: {
                                                __html: t("common:flexibleResourceManagementDesc")
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-sm font-semibold lg:text-base text-textGray",
                                            children: [
                                                "• ",
                                                t("common:advancedDataCenterInfrastructure")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm lg:text-base text-textGray",
                                            children: t("common:advancedDataCenterInfrastructureDesc")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var WindowsVirtualServers_TechnicalSpecificationsWindowsServers = (TechnicalSpecificationsWindowsServers);

;// CONCATENATED MODULE: ./components/WindowsVirtualServers/SecureAndUniqueVirtualServers.js




var SecureAndUniqueVirtualServers = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "windowsCloudServer"
    ]).t;
    var ref = (0,react.useState)(1), activeSection = ref[0], setActiveSection = ref[1];
    var containerRef = (0,react.useRef)(null);
    var titleRef = (0,react.useRef)(null);
    var title2Ref = (0,react.useRef)(null);
    var title3Ref = (0,react.useRef)(null);
    var sections = [
        {
            id: 1,
            title: t("common:makdosUniqueConfigurationOptions")
        },
        {
            id: 2,
            title: t("common:maximizeYourSecurityWithMakdos")
        },
        {
            id: 3,
            title: t("common:makdosSSLVPNAndAdditionalFeatures")
        }, 
    ];
    (0,react.useEffect)(function() {
        var handleScroll = function(e) {
            var containerBox = containerRef.current;
            var title = titleRef.current;
            var title2 = title2Ref.current;
            var title3 = title3Ref.current;
            var scroll = containerBox.scrollTop;
            var titleTop = title.getBoundingClientRect().top - containerBox.getBoundingClientRect().top;
            var title2Top = title2.getBoundingClientRect().top - containerBox.getBoundingClientRect().top;
            var title3Top = title3.getBoundingClientRect().top - containerBox.getBoundingClientRect().top;
            if (scroll >= titleTop && scroll < title2Top) {
                setActiveSection(1);
            } else if (scroll >= title2Top && scroll < title3Top) {
                setActiveSection(2);
            } else if (scroll >= title3Top) {
                setActiveSection(3);
            }
        };
        var container = containerRef.current;
        container.addEventListener("scroll", handleScroll);
        return function() {
            container.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container px-4 py-10 mx-auto lg:py-20 lg:px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "font-semibold text-3xl mb-3 lg:text-[40px] lg:text-center text-textGray",
                children: t("common:secureAndUniqueVirtualServers")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm lg:text-base lg:text-center text-textGray mx-auto lg:mx-[150px]",
                dangerouslySetInnerHTML: {
                    __html: t("common:secureAndUniqueVirtualServersDesc")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-2 gap-10 mt-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: containerRef,
                        className: "lg:h-[405px] col-span-2 lg:col-span-1 overflow-y-auto customScroll pr-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-xl lg:text-[24px] font-bold mb-4",
                                ref: titleRef,
                                children: sections[0].title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-lg leading-relaxed text-gray-600",
                                children: t("common:makdosUniqueConfigurationOptionsDesc")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "mt-4 space-y-2.5 text-gray-600",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("common:makdosUniqueConfigurationOptionsDesc2")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("common:makdosUniqueConfigurationOptionsDesc3")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("common:makdosUniqueConfigurationOptionsDesc4")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("common:makdosUniqueConfigurationOptionsDesc5")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("common:makdosUniqueConfigurationOptionsDesc6")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: t("common:makdosUniqueConfigurationOptionsDesc7")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-xl lg:text-[24px] font-bold mb-4 mt-10",
                                ref: title2Ref,
                                children: sections[1].title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-lg leading-relaxed text-gray-600",
                                dangerouslySetInnerHTML: {
                                    __html: t("common:maximizeYourSecurityWithMakdosDesc")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-xl lg:text-[24px] font-bold mb-4 mt-10",
                                ref: title3Ref,
                                children: sections[2].title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-lg leading-relaxed text-gray-600",
                                dangerouslySetInnerHTML: {
                                    __html: t("common:makdosSSLVPNAndAdditionalFeaturesDesc")
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative hidden lg:grid",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute left-0 flex flex-col justify-between h-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(activeSection === 1 ? "opacity-100" : "opacity-0", " transition-all duration-300"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/line1.svg",
                                            width: 194,
                                            height: 59,
                                            title: t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos"),
                                            alt: t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(activeSection === 2 ? "opacity-100" : "opacity-0", " transition-all duration-300"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/line2.svg",
                                            width: 81,
                                            height: 18,
                                            title: t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos"),
                                            alt: t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(activeSection === 3 ? "opacity-100" : "opacity-0", " transition-all duration-300"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/line3.svg",
                                            width: 185,
                                            height: 58,
                                            title: t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos"),
                                            alt: t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/secureAndUniqueVirtualServer.svg",
                                    width: 350,
                                    height: 350,
                                    alt: t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos"),
                                    title: t("windowsCloudServer:secureAndUniqueVirtualServersWithMakdos")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var WindowsVirtualServers_SecureAndUniqueVirtualServers = (SecureAndUniqueVirtualServers);

;// CONCATENATED MODULE: ./components/WindowsVirtualServers/DiscoverPowerOfMakdos.js



var DiscoverPowerOfMakdos = function() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "windowsCloudServer"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative px-4 py-10 lg:px-0 services bg-makdosSecondaryGray lg:py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-3xl mb-3 lg:mb-5 lg:text-[40px] lg:text-center font-bold",
                    children: t("common:discoverPowerOfMakdos")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto lg:mx-[210px] text-sm lg:text-base lg:text-center text-cardText",
                    dangerouslySetInnerHTML: {
                        __html: t("common:discoverPowerOfMakdosDesc")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center justify-center mt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/PowerOfMakdos.svg",
                        width: 563,
                        height: 494,
                        alt: t("common:discoverPowerOfMakdos"),
                        title: t("common:discoverPowerOfMakdos")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var WindowsVirtualServers_DiscoverPowerOfMakdos = (DiscoverPowerOfMakdos);

// EXTERNAL MODULE: ./components/CloudServers/MaxPerformanceWebSiteCloudServer.js
var MaxPerformanceWebSiteCloudServer = __webpack_require__(8421);
;// CONCATENATED MODULE: ./pages/servers/virtual-servers.js





















function virtualServers(param) {
    var datas = param.datas, rates = param.rates;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(), servers = ref[0], setServers = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,GlobalStore/* useGlobalStore */.s)(function(state) {
        return [
            state.setCurrencyRates
        ];
    }), 1), setCurrencyRates = ref1[0];
    var onGetVirtualServers = function() {
        var sortedData = datas.sort(function(a, b) {
            return a.order - b.order;
        });
        setServers(sortedData);
    };
    (0,react.useEffect)(function() {
        onGetVirtualServers();
    }, []);
    (0,react.useEffect)(function() {
        setCurrencyRates(rates);
    }, [
        rates
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("windowsMetaTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("windowsMetaDescription")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: t("windowsMetaTitle")
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: t("windowsMetaDescription")
                    }, "description")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full bg-no-repeat transform-gpu bg-physicalServerBg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container px-4 pt-20 pb-10 mx-auto lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between mb-14",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-xl",
                                            children: t("windowsCloudServer:title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "my-3 text-5xl font-semibold",
                                            children: t("windowsCloudServer:title2")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: t("windowsCloudServer:description")
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "justify-end flex-1 hidden lg:flex w-[329px] h-[118px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/virtualServerPriority.png",
                                        alt: t("windowsCloudServer:title2"),
                                        title: t("windowsCloudServer:title2"),
                                        width: "329",
                                        height: "118",
                                        priority: true,
                                        loading: "eager",
                                        className: "transform-gpu"
                                    })
                                })
                            ]
                        }),
                        servers ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full p-8 mb-20 overflow-x-auto bg-white rounded-md shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualServersTable/* default */.Z, {
                                servers: servers
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center w-full py-20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                type: "Oval",
                                color: "#FFDD00",
                                height: 50,
                                width: 50,
                                timeout: 3000
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center col-span-2 lg:col-span-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/virtualServers.svg",
                                        alt: t("windowsCloudServer:virtualServerHeading"),
                                        title: t("windowsCloudServer:virtualServerHeading"),
                                        width: 560,
                                        height: 460
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-span-2 pt-10 lg:col-span-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "py-8 text-4xl font-semibold lg:text-5xl",
                                            children: t("windowsCloudServer:virtualServerHeading")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-cardText text-md",
                                            children: t("windowsCloudServer:paragraph1")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-cardText text-md",
                                            children: t("windowsCloudServer:paragraph2")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WindowsVirtualServerServices, {
                servers: servers
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WindowsVirtualServers_WhatIsVirtualServer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WindowsVirtualServers_TechnicalSpecificationsWindowsServers, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WindowsVirtualServers_SecureAndUniqueVirtualServers, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WindowsVirtualServers_DiscoverPowerOfMakdos, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SSS/* default */.Z, {
                    data: router.locale === "tr" ? sss_tr_windows_sanal_sunucu_namespaceObject : sss_en_windows_sanal_sunucu_namespaceObject
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DidntFindForm/* default */.Z, {})
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var virtual_servers = (virtualServers);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2658,6716,4967,1736,9695,8421,9774,2888,179], function() { return __webpack_exec__(66229); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);